import moment from "moment";

const MomentDateUtils = {
    formateDateTime: (dateTime: string): string => {
        return moment(dateTime).format("DD/MM/YYYY HH:mm");
    },
};

export default MomentDateUtils;
